import {animate, state, style, transition, trigger} from '@angular/animations';

/**
 * Animation to turn an element from right to down.
 * @param msTransition - The duration of the transition in milliseconds.
 */
export const turnRightDownAnimation = (msTransition = 300) =>
  trigger('turnRightDown', [
    state(
      'right',
      style({
        transform: 'rotateZ(-90deg)',
      })
    ),
    state(
      'down',
      style({
        transform: 'rotateZ(0deg)',
      })
    ),
    transition('right <=> down', [animate(`${msTransition}ms ease-in`)]),
  ]);
